import { render, staticRenderFns } from "./LoanAmountSelector.vue?vue&type=template&id=735916fa&"
import script from "./LoanAmountSelector.vue?vue&type=script&lang=js&"
export * from "./LoanAmountSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports